export default __webpack_public_path__ + "static/media/latest-news-img23.926271c2.jpg";